/* Get user currently active session */
export const getUserSession = () => {

    return fetch("/api/auth/session")
        .then(res => res.json())
        .then(json => {
            return json;
        })
        .catch(err => {
            return err;
        });

}

/* Log user in and create new session. */
export const loginUser = (email, password) => {

    const body = {
        email,
        password,
    };

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    };

    return fetch("/api/auth/login", request)
        .then(res => res.json())
        .then(json => {
            return json;
        })
        .catch(err => {
            return err;
        });

}

/* Log user out and destory current session. */
export const logoutUser = () => {

    return fetch("/api/auth/logout")
        .then(res => res.json())
        .then(json => {
            return json;
        })
        .catch(err => {
            return err;
        });

}

/* Request password request */
export const requestPasswordReset = (email) => {

    const body = {
        email,
    };

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    };

    return fetch("/api/auth/send-reset-password-code", request)
        .then(res => res.json())
        .then(json => {
            return json;
        })
        .catch(err => {
            return err;
        });

}

/* Request password request */
export const resetPassword = (passwordResetCode, password) => {

    const body = {
        passwordResetCode,
        password,
    };

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    };

    return fetch("/api/auth/reset-password", request)
        .then(res => res.json())
        .then(json => {
            return json;
        })
        .catch(err => {
            return err;
        });

}

/* Update user props */
export const updateUser = (id, data) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id,
            data,
        }),
    };

    return fetch("/api/users/update/", request)
        .then(res => res.json())
        .then(result => {
            return result;
        })
        .catch(err => {
            return err;
        });

}

/* Delete user with userType === Candidate */
export const deleteUserCandidate = (user) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            user,
        }),
    };

    return fetch("/api/users/delete-candidate-account/", request)
        .then(res => res.json())
        .then(result => {
            return result;
        })
        .catch(err => {
            return err;
        });

}

/* Check previous password */
export const checkPreviousPassword = (id, password) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id,
            password,
        }),
    };

    return fetch("/api/auth/check-previous-password", request)
        .then(res => res.json())
        .then(result => {
            return result;
        })
        .catch(err => {
            return err;
        });

}

/* Check email */
export const checkEmail = (email) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email,
        }),
    };

    return fetch("/api/auth/check-email", request)
        .then(res => res.json())
        .then(result => {
            return result;
        })
        .catch(err => {
            return err;
        });

}

/* Change password */
export const changePassword = (id, password) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id,
            password,
        }),
    };

    return fetch("/api/auth/change-password", request)
        .then(res => res.json())
        .then(result => {
            return result;
        })
        .catch(err => {
            return err;
        });

}

/* Get user data as an Admin */
export const getUserData = (id) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id,
        }),
    };

    return fetch("/api/users/data/", request)
        .then(res => res.json())
        .then(result => {
            return result.user;
        })
        .catch(err => {
            return err;
        });

}

/* Request a magic link login code by email */
export const sendMagicLink = (email) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
    };

    return fetch("/api/auth/send-magic-link", request)
        .then(res => res.json())
        .then(json => json)
        .catch(err => err);

}

/* Unified auth: lookup email - if exists, sends code; if not, returns exists=false */
export const lookupEmail = (email) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
    };

    return fetch("/api/auth/lookup-email", request)
        .then(res => res.json())
        .then(json => json)
        .catch(err => err);

}

/* Register a new passwordless Candidate account - server sends a magic code */
export const registerPasswordless = (firstName, lastName, email) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ firstName, lastName, email }),
    };

    return fetch("/api/auth/register-passwordless", request)
        .then(res => res.json())
        .then(json => json)
        .catch(err => err);

}

/* Verify magic link code and log in */
export const verifyMagicLink = (email, code) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, code }),
    };

    return fetch("/api/auth/verify-magic-link", request)
        .then(res => res.json())
        .then(json => json)
        .catch(err => err);

}

/* Admin-only: swap the current session to act as the target user. Server
   parks the admin identity so endImpersonation can restore it. */
export const adminSignInAs = (userId) => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetch(`/api/auth/admin-sign-in-as/${userId}`, request)
        .then(res => res.json())
        .then(json => json)
        .catch(err => err);

}

/* End impersonation and restore the parked admin session. */
export const endImpersonation = () => {

    const request = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
    };

    return fetch("/api/auth/end-impersonation", request)
        .then(res => res.json())
        .then(json => json)
        .catch(err => err);

}